module.exports = __webpack_public_path__ + "img/72.38afe738.jpg";